import React, { useContext, useEffect } from 'react'
import SilageStepLayout from '../SilageStepLayout'
import { Checkbox, Form, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { StyledGroup } from '../GrassSilageStep/style'
import { StyledDivider } from '../ElevenStep/style'
import { ClimaOptionsContext } from '.'
import { StepId } from '../../constants'

const tableColumnHeaders = [
  {
    name: 'Arbeitsgänge',
    key: 'label'
  },
  {
    name: 'Anzahl der Durchgänge',
    key: 'passages',
    type: 'input',
    unit: 'Durchgänge'
  },
  {
    name: 'Entfernung',
    key: 'distance',
    type: 'input',
    unit: 'km'
  }
]

const ThirdGrassStep: React.FC = () => {
  const { control, setValue, clearErrors, getValues } = useFormContext()
  const { silageTypes, pestProtectionIntensities } = useContext(ClimaOptionsContext)

  const watchPlantProtection = useWatch({ control, name: 'maizeSilage.pestProtectionIntensity' })
  const workOperations = silageTypes.find(silageType => silageType.slug === StepId.CORN_SILAGE)?.workOperations || []

  useEffect(() => {
    const workOperationsValues = getValues('maizeSilage.workOperations') || []
    if (workOperationsValues.length === 0 || !workOperationsValues[0]?.id) {
      const workOperationsTemp = workOperations.map(workOperation => ({ id: workOperation.id, distance: '', passages: '' }))
      setValue('maizeSilage.workOperations', workOperationsTemp)
    }
  }, [])

  function renderInputCellValue(name, unit: string) {
    return <FormFields.Input
      placeholder={`in ${unit}`}
      name={name}
      suffix={` ${unit}`}
      onChange={(event) => {
        setValue(name, event?.target?.value?.replace(unit, ''))
        clearErrors(name)
      }}
      rules={{
        required: true
      }}
      control={control}
      typeInput={'controled'}
      withoutAsterisk
      noErrorMessage
      allowDecimals
      decimalScale={1}
    />
  }


  function renderCell(workOperation, name, column) {
    switch (column.type) {
      case 'input':
        return renderInputCellValue(name, column?.unit)
      default:
        return workOperation[column.key]
    }
  }

  function renderTableBody() {
    return workOperations.map((workOperation, indexFertilizer) => {
      return <Table.Row key={workOperation.id}>
        {tableColumnHeaders.map(column => {
          const name = `maizeSilage.workOperations[${indexFertilizer}].${column.key}`
          return <Table.Cell key={`${column.key}-${column.key}`}>
            {renderCell(workOperation, name, column)}
          </Table.Cell>
        })}
      </Table.Row>
    })
  }


  function renderTable() {
    return <Table celled striped compact>
      <Table.Header>
        <Table.Row>
          {tableColumnHeaders.map(header => {
            return <Table.HeaderCell key={header.key}>
              {header.name}
            </Table.HeaderCell>
          })}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {renderTableBody()}
      </Table.Body>
    </Table>
  }

  return (
    <SilageStepLayout
      infoText={`Die Erfassung der Arbeitsgänge wird benötigt, um den Dieselverbrauch je ha zu berechnen. 
        Tragen Sie die Anzahl der Durchgänge bzw. die Feld-Silo-Entfernung für die jeweiligen Arbeitsgänge ein. 
        Die Herstellung von Saatgut und Pflanzenschutzmitteln verursacht Treibhausgasemissionen.`}
    >
      {renderTable()}
      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='maizeSilage.pestProtectionIntensity'
          rules={{
            required: true
          }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Pflanzenschutzintensität'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', gap: 30 }}>
                {pestProtectionIntensities.map(pestProtection => {
                  return <Checkbox
                    key={pestProtection.key}
                    label={pestProtection.label}
                    checked={watchPlantProtection === pestProtection.key}
                    onClick={() => {
                      setValue('maizeSilage.pestProtectionIntensity', pestProtection.key)
                      clearErrors('maizeSilage.pestProtectionIntensity')
                    }}
                  />
                })}
              </div>
            </Form.Field>
          )}
        />
        <FormFields.Input
          control={control}
          rules={{
            required: true
          }}
          withoutAsterisk
          noErrorMessage
          suffix=' ha'
          typeInput={'controled'}
          label={<div className='title' style={{ width: 'fit-content' }}>
            <div>{'Saatgutmenge'}</div>
            < StyledDivider />
          </div>}
          placeholder={'in ha'}
          name={'maizeSilage.seedUsed'}
        />
      </StyledGroup>
    </SilageStepLayout>
  )
}

export default ThirdGrassStep